import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import StoreContext from './context';
import { getUser } from './api';

const StoreProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [customer, setCustomer] = useState(null);
  const [jewelryTypes, setJewelryTypes] = useState([]);
  const [gems, setGems] = useState([]);
  const [metals, setMetals] = useState([]);
  const [collections, setCollections] = useState([]);
  const [products, setProducts] = useState([]);
  const [videoPlaying, setVideoPlaying] = useState(true);
  const [mobileNav, setMobileNav] = useState(false);
  const [chatStatus, setChatStatus] = useState(true);
  const [modal, setModal] = useState({
    show: false,
    title: '',
    text: '',
  });

  useEffect(() => {
    if (!user) {
      setUser(getUser());
    }
  }, []);

  const value = {
    state: {
      jewelryTypes,
      gems,
      metals,
      collections,
      products,
      modal,
      videoPlaying,
      mobileNav,
      chatStatus,
      user,
      customer,
    },
    actions: {
      setJewelryTypes,
      setGems,
      setMetals,
      setCollections,
      setProducts,
      setModal,
      setVideoPlaying,
      setMobileNav,
      setChatStatus,
      setUser,
      setCustomer,
    },
  };

  return (
    <StoreContext.Provider value={value}>{children}</StoreContext.Provider>
  );
};

StoreProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default StoreProvider;
